import { Link } from "gatsby"
import React from "react"
import Container from "react-bootstrap/Container"
import Nav from "react-bootstrap/Nav"
import Navbar from "react-bootstrap/Navbar"
import styled from "styled-components"

const NavItem = styled.div.attrs({
  className: "nav-item overline",
})``

const Header = ({ fixedNavbar }) => (
  <Navbar
    expand="lg"
    fluid
    variant={fixedNavbar ? "dark" : null}
    fixed={fixedNavbar ? "top" : null}
    style={{
      backgroundImage:
        fixedNavbar &&
        "linear-gradient(to bottom, rgba(0,0,0,.7) , rgba(0,0,0,0))",
      zIndex: 1,
    }}
  >
    <Container fluid>
      <Navbar.Brand>
        <a
          href="https://www.hua-gallery.com"
          className={`text-decoration-none ${fixedNavbar && "text-white"}`}
        >
          <div style={{ fontWeight: 400, fontSize: "2rem" }}>H U A</div>
        </a>
      </Navbar.Brand>

      <Navbar.Toggle className="overline px-2 py-1">Menu</Navbar.Toggle>

      <Navbar.Collapse>
        <Nav>
          <NavItem>
            <Link
              className="nav nav-link text-decoration-none"
              to="/spotlights"
            >
              Spotlights
            </Link>
          </NavItem>
          <NavItem>
            <a
              className="nav nav-link text-decoration-none"
              href="https://hua-gallery.com/pages/artists"
            >
              Artists
            </a>
          </NavItem>
          <NavItem>
            <a
              className="nav nav-link text-decoration-none"
              href="https://hua-gallery.com/pages/special-projects"
            >
              Special Projects
            </a>
          </NavItem>
          <NavItem>
            <a
              className="nav nav-link text-decoration-none"
              href="https://hua-gallery.com/pages/about"
            >
              About & Contact
            </a>
          </NavItem>
        </Nav>
      </Navbar.Collapse>
    </Container>
  </Navbar>
)

export default Header
